/**
 * Query system exports
 * 
 * The query system implements the PC communication system (ADR-018)
 * for handling player queries and responses.
 */

export * from './types';
export * from './query-manager';
